// extracted by mini-css-extract-plugin
module.exports = {"buyer":"styles_buyer__SDA23","selected-buyer":"styles_selected-buyer__ubaTe","nextBtn":"styles_nextBtn__VLNm6"};